import api from './base'
import { objectToQueryString } from '../utils/object'

export default {
  getAll ({ businessUnitId, filters }) {
    return api().get(`company/business_units/${businessUnitId}/inventories?${objectToQueryString(filters)}`)
  },
  getById ({ businessUnitId, id }) {
    return api().get(`company/business_units/${businessUnitId}/inventories/${id}?includeArticles=true`)
  },
  getInventoryList ({ businessUnitId, inventoryId }) {
    return api().get(`company/business_units/${businessUnitId}/inventories/${inventoryId}/inventory_list`)
  },
  save ({ businessUnitId, item }) {
    return api().put(`company/business_units/${businessUnitId}/inventories`, item)
  },
  saveArticles ({ businessUnitId, inventoryId, item }) {
    return api().put(`company/business_units/${businessUnitId}/inventories/${inventoryId}/articles`, item)
  },
  delete ({ businessUnitId, id }) {
    return api().delete(`company/business_units/${businessUnitId}/inventories/${id}`)
  },
  getPDFList ({ businessUnitId, inventoryId }) {
    return api().get(`company/business_units/${businessUnitId}/inventories/${inventoryId}/inventory_list/pdf`)
  }
}
